import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ position: string }>`
  position: relative;
  display: inline-block;

  div.input-wrapper {
    min-width: 150px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    line-height: 1;
    z-index: 100;
    white-space: nowrap;

    &::before {
      content: ' ';
      left: 50%;
      border: solid transparent;
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-width: 0px 9px 10px;
      border-color: ${({ theme }) => theme.colors.main} transparent;
    }

    ${({ position }) =>
      position === 'left' &&
      css`
        left: auto;
        right: calc(100% + 8px);
        top: 50%;
        transform: translateX(0) translateY(-50%);

        &::before {
          left: auto;
          right: calc(6px * -2);
          top: 40%;
          transform: translateX(0) translateY(-40%) rotate(90deg);
        }
      `}

    ${({ position }) =>
      position === 'right' &&
      css`
        left: calc(100% + 8px);
        top: 50%;
        transform: translateX(0) translateY(-50%);

        &::before {
          left: calc(6px * -2);
          top: 40%;
          transform: translateX(0) translateY(-40%) rotate(270deg);
        }
      `}
  }
`;
